export interface EventLogResponseDTO {
  id: string;
  category: string;
  eventType: string;
  status: string;
  severity: string;
  source: string;
  message: string;
  details?: string;
  entityType?: string;
  entityId?: string;
  actorId?: string;
  actorRole?: string;
  provider?: string;
  recipient?: string;
  subject?: string;
  orderId?: string;
  companyId?: string;
  correlationId?: string;
  httpMethod?: string;
  httpPath?: string;
  httpStatus?: number;
  errorCode?: string;
  errorMessage?: string;
  metadata?: string;
  createdAt: string;
}

export interface EventLogSearchRequestDTO {
  category?: string;
  status?: string;
  severity?: string;
  eventType?: string;
  entityType?: string;
  entityId?: string;
  actorId?: string;
  actorRole?: string;
  source?: string;
  provider?: string;
  orderId?: string;
  companyId?: string;
  correlationId?: string;
  httpStatus?: number;
  errorCode?: string;
  text?: string;
  fromDate?: string;
  toDate?: string;
}

export interface EventLogStatsDTO {
  total: number;
  failures: number;
  errors: number;
  byCategory: Record<string, number>;
  byStatus: Record<string, number>;
}

export const EVENT_CATEGORIES = ["PAYMENT", "EMAIL", "NOTIFICATION", "AUTH", "AUDIT", "ERROR", "SYSTEM", "API"] as const;

export const EVENT_STATUSES = ["SUCCESS", "FAILED", "PARTIAL_SUCCESS", "WARN", "SKIPPED", "PENDING", "CANCELLED"] as const;

export const EVENT_SEVERITIES = ["INFO", "WARN", "ERROR"] as const;

export const LIVE_EVENTS_TOPIC = "/topic/event-logs";